// material-ui
import {
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
} from '@mui/material'
import * as localStorageService from 'components/localStorageService'
import * as firebaseapp from 'features/firebase-app'
import { ResolvePath, ResolveStorageUrl } from 'features/firebase-app'
import React from 'react'
import { useNavigate, useParams } from 'react-router-dom'

import { Button, Grid } from '@mui/material'
import rq from 'components/RedQuick'
import {
  mobileAndTabletCheck,
  useBrowserInfo,
  useLocalId,
  useStutter,
} from 'components/utility'
import * as applicationSlice from 'features/application/application-slice'
import { SNACKBAR_OPEN } from 'store/actions'
import { gridSpacing } from 'store/constant'
import TitleService from 'title-service'

import { Views } from 'features/enumerations'

// assets
import * as autoThunks from 'features/auto-thunks'
import { useEffect } from 'react'

import CacheLoad from 'components/CacheLoad'
import CoherentScreenViewComponent from 'components/CoherentScreenViewComponent'
import ModelLoader from 'components/ModelLoader'
import PlaywatchGoMobile from 'components/PlaywatchGoMobile'
import PreviewCoherentScreenModelComponent from 'components/PreviewCoherentScreenModelComponent'
import PreviewSeriesPopupComponent from 'components/PreviewSeriesPopupComponent'
import QuickLoadResourceCreateComponent from 'components/QuickLoadResourceCreateComponent'
import { getUserClaims } from 'features/application/application-slice'
import { get_all_approvedMedia } from 'features/approvedMedia/approvedMedia-slice'
import { get_all_approvedSeries } from 'features/approvedSeries/approvedSeries-slice'
import {
  get_all_coherentScreen,
  get_selected_coherentScreen,
  setSelectedcoherentScreen,
} from 'features/coherentScreen/coherentScreen-slice'
import { get_all_curatedMediaList } from 'features/curatedMediaList/curatedMediaList-slice'
import { get_all_curatedSeriesList } from 'features/curatedSeriesList/curatedSeriesList-slice'
import { get_all_processedMedia } from 'features/processedMedia/processedMedia-slice'
import {
  get_selected_profile,
  mergeprofile,
  setSelectedprofile,
} from 'features/profile/profile-slice'
import { get_all_watchingProfileMetric } from 'features/watchingProfileMetric/watchingProfileMetric-slice'
import { ProcessedMedia } from 'models'
import { useDispatch, useSelector } from 'react-redux'

// ================================|| UI LIST - SIMPLE LIST ||================================ //

export default function SimpleList() {
  // Generate Grid
  const params = useParams()
  let dispatch = useDispatch()
  const navigate = useNavigate()
  let claims = useSelector(getUserClaims)
  let profile = useSelector(get_selected_profile)
  let coherentScreen_list = useSelector(get_all_coherentScreen)
  let coherentScreen = useSelector(get_selected_coherentScreen)
  let curatedSeriesList_list = useSelector(get_all_curatedSeriesList)
  let curatedMediaList_list = useSelector(get_all_curatedMediaList)
  let approvedSeries_list = useSelector(get_all_approvedSeries)
  let approvedMedia_list = useSelector(get_all_approvedMedia)
  let processedMedia_list = useSelector(get_all_processedMedia)
  let watchingProfileMetric_list = useSelector(get_all_watchingProfileMetric)
  const [currentSeasonId, setCurrentSeasonId] = React.useState(null)
  const [selectedSeasonIndex, setSelectedSeasonIndex] = React.useState(null)
  const [urlUpdated, setUrlUpdated] = React.useState(null)
  const [profilesLoaded, setProfilesLoaded] = React.useState(null)
  const [deviceArgs, setDeviceArgs] = React.useState(null)
  const [processedMediaId, setProcessedMediaId] = React.useState(null)
  const [watchingMediaDicArgs, setWatchingMediaDicArgs] = React.useState(null)
  const [previewMetric, setPreviewMetric] = React.useState(null)
  const [prcessedMediaDownloadableUrls, setPrcessedMediaDownloadableUrls] =
    React.useState(null)
  const [watchingMediaObject, setWatchingMediaObject] = React.useState(null)
  const [previewDicMetric, setPreviewDicMetric] = React.useState(null)
  const [viewPreviewObject, setViewPreviewObject] = React.useState(null)
  const [mediaStateLib, setMediaStateLib] = React.useState(null)
  const [videoStateLib, setVideoStateLib] = React.useState(null)
  const [cacheUrlArgs, setCacheUrlArgs] = React.useState(null)

  const componentRef: React.Ref<HTMLDivElement> = React.useRef(null)
  const componentRef_size = rq.useContainerSize(componentRef)
  const localDeviceId = useLocalId()
  const browserInfo = useBrowserInfo()
  const watchingMediaArgs = useStutter(
    JSON.stringify(watchingMediaObject),
    5000,
  )
  const watchingMediaDicObject = useStutter(
    JSON.stringify(watchingMediaDicArgs),
    10000,
  )
  const previewDicMetricObject = useStutter(
    JSON.stringify(previewDicMetric),
    10000,
  )
  const viewPreviewArgs = useStutter(JSON.stringify(viewPreviewObject), 3000)

  useEffect(() => {
    if (claims?.user && getSeriesId() && !isBrowseMode()) {
      dispatch(
        autoThunks.get_approved_series_by_series_id({
          seriesId: (() => {
            function getComponentParam(): any {
              return params?.component
            }
            return getComponentParam()
          })(),
        }),
      )
    }
  }, [claims?.user, getSeriesId(), !isBrowseMode()])
  useEffect(() => {
    if (claims?.user && getMediaId() && !isBrowseMode()) {
      dispatch(
        autoThunks.get_approved_media_by_media_id({
          mediaId: (() => {
            function getComponentParam(): any {
              return params?.component
            }
            return getComponentParam()
          })(),
        }),
      )
    }
  }, [claims?.user, getMediaId(), !isBrowseMode()])
  useEffect(() => {
    if (claims?.user && params?.id && getSeriesOwner() && isBrowseMode()) {
      dispatch(
        autoThunks.get_approved_media_by_owner({
          owner: (() => {
            function getSeriesOwner(): any {
              let tempApprovedSeries: any = null
              if (params?.component) {
                tempApprovedSeries = approvedSeries_list.find(
                  (v) => v.seriesId === params?.component,
                )
              }
              return tempApprovedSeries?.series?.owner
            }
            return getSeriesOwner()
          })(),
        }),
      )
    }
  }, [claims?.user, params?.id, getSeriesOwner(), isBrowseMode()])
  useEffect(() => {
    if (claims?.user && params?.id) {
      function setSelectedCoherentScreen(): any {
        dispatch(setSelectedcoherentScreen(params?.id || null))
      }
      setSelectedCoherentScreen()
    }
  }, [claims?.user, params?.id])
  useEffect(() => {
    if (claims?.user && coherentScreen?.highlightSeriesId && !isBrowseMode()) {
      dispatch(
        autoThunks.get_approved_series_by_highlightseries_id({
          seriesId: (() => {
            function getserieshighlightid(): any {
              return coherentScreen?.highlightSeriesId
            }
            return getserieshighlightid()
          })(),
        }),
      )
    }
  }, [claims?.user, coherentScreen?.highlightSeriesId, !isBrowseMode()])
  useEffect(() => {
    function routeToProfileSelect(): any {
      if (getLocationPath() === Views.Browse) {
        if (!profile?.id) {
          let data = localStorageService.load('ProfileId')
          if (profilesLoaded) {
            localStorageService.store(
              profilesLoaded,
              `profiles-${claims?.user}`,
            )
            if (data && data.profileId && profilesLoaded?.data?.length) {
              let found_profile = profilesLoaded?.data?.find(
                (v) => v.id === data?.profileId,
              )
              if (found_profile) {
                dispatch(setSelectedprofile(data.profileId))
                dispatch(
                  applicationSlice.setProfileImage(found_profile.profileImage),
                )
                dispatch(applicationSlice.setProfileName(found_profile.name))
              } else {
                navigate(`/${Views.SelectProfile}`, { replace: true })
              }
            } else {
              navigate(`/${Views.SelectProfile}`, { replace: true })
            }
          }
        }
      }
    }
    routeToProfileSelect()
  }, [profile?.id, profilesLoaded])
  useEffect(() => {
    dispatch(
      autoThunks.get_profile_history({
        fireid: claims?.fire_user,
        profileId: (() => {
          function getProfileId(): any {
            return profile?.id
          }
          return getProfileId()
        })(),
      }),
    )
  }, [claims?.user, profile?.id])
  useEffect(() => {
    if (claims?.user) {
      dispatch(
        autoThunks.load_profiles({
          userId: claims?.fire_user,
          callback: (success: boolean, res: any) => {
            if (success) {
              onProfileLoadSuccess(success, res)
            } else {
              onProfileFail()
            }
          },
        }),
      )
    }
  }, [claims?.user])
  useEffect(() => {
    if (claims?.user) {
      dispatch(autoThunks.load_approved_media({ ok: true }))
    }
  }, [claims?.user])
  useEffect(() => {
    if (claims?.user && !approvedSeries_list?.length) {
      dispatch(autoThunks.load_approved_series({ ok: true }))
    }
  }, [claims?.user])
  useEffect(() => {
    if (claims?.user && claims?.account && deviceArgs && false) {
      dispatch(
        autoThunks.add_user_device({
          userId: claims?.user,
          deviceArgs: (() => {
            function getDeviceArgs(): any {
              return deviceArgs
            }
            return getDeviceArgs()
          })(),
        }),
      )
    }
  }, [claims?.user, claims?.account, deviceArgs, false])
  useEffect(() => {
    if (claims?.user) {
      dispatch(autoThunks.ensure_user_account({ userId: claims?.user }))
    }
  }, [claims?.user])
  useEffect(() => {
    if (browserInfo && localDeviceId?.id) {
      function local_device_changes(): any {
        if (localDeviceId?.id && browserInfo) {
          setDeviceArgs({
            ...browserInfo,
            localDeviceId: localDeviceId?.id,
          })
        }
      }
      local_device_changes()
    }
  }, [browserInfo, localDeviceId?.id])
  useEffect(() => {
    if (
      claims?.user &&
      watchingMediaArgs &&
      watchingMediaDicArgs &&
      previewDicMetric
    ) {
      dispatch(
        autoThunks.on_view_preview_media({
          userId: claims?.user,
          watchingMediaDicArgs: (() => {
            function getwatchingMediaDicArgs(): any {
              return watchingMediaDicArgs
            }
            return getwatchingMediaDicArgs()
          })(),
          previewDicMetric: (() => {
            function getPreviewDicMetric(): any {
              return previewDicMetric
            }
            return getPreviewDicMetric()
          })(),
        }),
      )
    }
  }, [claims?.user, watchingMediaDicObject, previewDicMetricObject])
  useEffect(() => {
    if (
      claims?.user &&
      viewPreviewArgs &&
      viewPreviewObject?.device &&
      viewPreviewObject?.profile
    ) {
      dispatch(
        autoThunks.on_view_preview({
          userId: claims?.user,
          viewPreviewArgs: (() => {
            function getviewPreviewObject(): any {
              return viewPreviewObject
            }
            return getviewPreviewObject()
          })(),
        }),
      )
    }
  }, [claims?.user, viewPreviewArgs, viewPreviewObject])
  useEffect(() => {
    if (claims?.user) {
      dispatch(
        autoThunks.get_processed_media_for_view({
          profileId: (() => {
            function get_profile_id(): any {
              return profile?.id
            }
            return get_profile_id()
          })(),
        }),
      )
    }
  }, [claims?.user])
  useEffect(() => {
    if (
      claims?.user &&
      processedMedia_list?.length &&
      componentRef_size.width
    ) {
      function onProcessedMediaUpdate(): any {
        let videoResultLib: any = {}
        let imageResultLib: any = {}
        if (componentRef_size.width) {
          processedMedia_list.forEach((pm: ProcessedMedia) => {
            let videoStates = pm.states.filter(
              (x) => x.resourcePropertyType === 'MediaPreviewUrl',
            )
            let imageStates = pm.states.filter(
              (x) => x.resourcePropertyType === 'TransparentTitleUrl',
            )
            let videoOrderedStates = videoStates.sort((a, b) => {
              let a_ = Math.abs(a.width - componentRef_size.width / 3)
              let b_ = Math.abs(b.width - componentRef_size.width / 3)
              return a_ - b_
            })
            if (videoOrderedStates.length) {
              videoResultLib[pm.mediaId] = videoOrderedStates[0]
            }
            let imageOrderedStates = imageStates.sort((a, b) => {
              let a_ = Math.abs(a.width - componentRef_size.width / 3)
              let b_ = Math.abs(b.width - componentRef_size.width / 3)
              return a_ - b_
            })
            if (imageOrderedStates.length) {
              imageResultLib[imageOrderedStates[0].mediaId] =
                imageOrderedStates[0]
              ResolveStorageUrl(imageOrderedStates[0].location)
            }
          })
        }
        setMediaStateLib(imageResultLib)
        setVideoStateLib(videoResultLib)
      }
      onProcessedMediaUpdate()
    }
  }, [claims?.user, processedMedia_list?.length, componentRef_size.width])
  useEffect(() => {
    if (claims?.player && cacheUrlArgs) {
      dispatch(
        autoThunks.update_cache_media_urls({
          playerId: claims?.player,
          cacheUrlArgs: (() => {
            function getCachedUrlArgs(): any {
              return cacheUrlArgs
            }
            return getCachedUrlArgs()
          })(),
        }),
      )
    }
  }, [claims?.player, cacheUrlArgs])
  useEffect(() => {
    if (claims?.user) {
      dispatch(
        autoThunks.load_cache_media_urls({
          userId: claims?.user,
          callback: (success: boolean, res: any) => {
            if (success) {
              onLoadCacheMediaUrls(success, res)
            } else {
              onLoadCacheMediaUrlFail()
            }
          },
        }),
      )
    }
  }, [claims?.user])
  useEffect(() => {
    dispatch(
      autoThunks.get_profile_history_metrics({
        fireid: claims?.fire_user,
        profileId: (() => {
          function getProfileId(): any {
            return profile?.id
          }
          return getProfileId()
        })(),
      }),
    )
  }, [claims?.user, profile?.id])
  useEffect(() => {
    function loadCachedProfiles(): any {
      if (getLocationPath() === Views.Browse) {
        if (claims?.user) {
          let _profilesLoaded = localStorageService.load(
            `profiles-${claims?.user}`,
          )
          if (_profilesLoaded) {
            let data = localStorageService.load('ProfileId')
            let found_profile = _profilesLoaded?.data?.find(
              (v) => v.id === data?.profileId,
            )
            if (data && data.profileId && _profilesLoaded?.data?.length) {
              if (found_profile) {
                dispatch(setSelectedprofile(data.profileId))
                dispatch(
                  applicationSlice.setProfileImage(found_profile.profileImage),
                )
                dispatch(applicationSlice.setProfileName(found_profile.name))
                dispatch(mergeprofile(_profilesLoaded))
              } else {
                navigate(`/${Views.SelectProfile}`, { replace: true })
              }
            }
          } else {
            navigate(`/${Views.SelectProfile}`, { replace: true })
          }
        }
      }
    }
    loadCachedProfiles()
  }, [claims?.user])

  function getSeriesOwner(): any {
    let tempApprovedSeries: any = null
    if (params?.component) {
      tempApprovedSeries = approvedSeries_list.find(
        (v) => v.seriesId === params?.component,
      )
    }
    return tempApprovedSeries?.series?.owner
  }

  function getLocationPath(): string {
    if (location.href.indexOf(Views.PreviewCoherentScreen) !== -1) {
      return Views.PreviewCoherentScreen
    }
    return Views.Browse
  }

  function isBrowseMode(): boolean {
    if (location.href.indexOf(Views.PreviewCoherentScreen) !== -1) {
      return false
    }
    return true
  }

  function getMediaId(): any {
    return params?.component
  }

  function getSeriesId(): any {
    return params?.component
  }

  function onProfileLoadSuccess(success: any, res: any) {
    setProfilesLoaded(res)
  }

  function onProfileFail() {
    setProfilesLoaded(true)
    console.log('profiles failed to load')
    dispatch({
      type: SNACKBAR_OPEN,
      open: true,
      message: TitleService(`Failed to load profiles`),
      variant: 'alert',
      alertSeverity: 'error',
    })
  }

  function onLoadCacheMediaUrlFail(): any {
    console.error('failed to load media urls')
  }

  function onLoadCacheMediaUrls(success: any, res: any): any {
    if (res?.data) {
      res?.data?.forEach((item) => {
        let { cache } = item
        firebaseapp.MergeCachedUrls(cache)
      })
    }
  }

  function main_card(modelList: any): any {
    return (() => {
      if (mobileAndTabletCheck()) {
        return (
          <>
            <CacheLoad>
              <ModelLoader />
              <PlaywatchGoMobile />
            </CacheLoad>
          </>
        )
      } else {
        return (
          <CacheLoad>
            <>
              <ModelLoader />
              <Grid container spacing={gridSpacing}>
                {!isBrowseMode() && <QuickLoadResourceCreateComponent />}
                {!isBrowseMode() && false && (
                  <Grid item xs={12}>
                    <Button
                      variant="outlined"
                      onClick={() => {
                        setCacheUrlArgs(firebaseapp.GetAllCachedUrls())
                      }}
                    >
                      {TitleService('Store Cached Urls')}
                    </Button>
                  </Grid>
                )}
                {!isBrowseMode() && false && (
                  <Grid item xs={12}>
                    <FormControl sx={{ m: 1, minWidth: 120 }}>
                      <InputLabel id="coherentScreen-label">
                        {TitleService('Coherent Screen')}
                      </InputLabel>
                      <Select
                        labelId="coherentScreen-label"
                        id="coherentScreen-select"
                        value={params?.id}
                        label={TitleService('Coherent Screen')}
                        onChange={(val: any) => {
                          dispatch(
                            setSelectedcoherentScreen(val?.target?.value),
                          )
                          navigate(
                            ResolvePath(
                              `/${getLocationPath()}/${val?.target?.value}`,
                            ),
                          )
                        }}
                      >
                        <MenuItem value="">
                          {TitleService('Select Content House')}
                        </MenuItem>
                        {(coherentScreen_list || []).map((item) => {
                          return (
                            <MenuItem value={item.id} key={item.id}>
                              {item.name}
                            </MenuItem>
                          )
                        })}
                      </Select>
                      <FormHelperText>
                        {TitleService('Select a series')}
                      </FormHelperText>
                    </FormControl>
                  </Grid>
                )}
                {
                  <Grid item xs={12}>
                    {!isBrowseMode() && (
                      <CoherentScreenViewComponent
                        coherentScreen={coherentScreen}
                        coherentScreen_list={coherentScreen_list}
                        approvedSeries_list={approvedSeries_list}
                        approvedMedia_list={approvedMedia_list}
                        curatedSeriesList_list={curatedSeriesList_list}
                        watchingProfileMetric_list={watchingProfileMetric_list}
                        curatedMediaList_list={curatedMediaList_list}
                      />
                    )}
                    {isBrowseMode() && (
                      <PreviewCoherentScreenModelComponent
                        coherentScreen={coherentScreen}
                        coherentScreen_list={coherentScreen_list}
                        approvedSeries_list={approvedSeries_list}
                        approvedMedia_list={approvedMedia_list}
                        curatedSeriesList_list={curatedSeriesList_list}
                        watchingProfileMetric_list={watchingProfileMetric_list}
                        curatedMediaList_list={curatedMediaList_list}
                      />
                    )}
                  </Grid>
                }
              </Grid>
              <PreviewSeriesPopupComponent
                approvedSeries_list={approvedSeries_list}
                approvedMedia_list={approvedMedia_list}
                componentRef_size={componentRef_size}
              />
            </>
          </CacheLoad>
        )
      }
    })()
  }

  let output_main_card = main_card(null)

  return output_main_card
}
